import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { checkValidation } from '../actions/landingActions';
import {
  fetchQuoteDetails,
  fetchAutoPolicy,
  getCustomerFeedback,
  getPaymentOptionCheckState,
  getAdditionalOptionsCheckState,
  getOtherCoveragesCheckState,
  getPaymentModeButtonStatus,
  getSeePaymentOptionButtonStatus,
} from '../../src/selectors/quoteServiceSelector';
import {
  getAuthtoken,
  getQuoteDetailsdata,
} from '../selectors/getQuoteSelectors';
import { jwtDecode } from 'jwt-decode';
import { USERTYPE } from '../constants';
import {
  // quoteServiceDetails,
  setCustomerFeedback,
  setSublobDataState,
} from '../actions/quoteServiceAction';
export const useQuoteService = (sublob) => {
  const dispatch = useDispatch();
  const getQuote = useSelector(getQuoteDetailsdata);
  const authtoken = useSelector(getAuthtoken);
  const getQuoteData = useSelector(fetchQuoteDetails);
  const autoPolicyDetails = useSelector(fetchAutoPolicy);
  const customerFeedback = useSelector(getCustomerFeedback);
  const paymentOptionsCheckState = useSelector(
    getPaymentOptionCheckState(sublob?.toLowerCase()),
  );
  const additionalOptionsCheckState = useSelector(
    getAdditionalOptionsCheckState(sublob?.toLowerCase()),
  );
  const otherCoveragesCheckState = useSelector(getOtherCoveragesCheckState);
  const paymentModeButtonStatus = useSelector(
    getPaymentModeButtonStatus(sublob?.toLowerCase()),
  );
  const seePaymentOptionButtonStatus = useSelector(
    getSeePaymentOptionButtonStatus(sublob?.toLowerCase()),
  );

  const quoteDetails = useCallback(
    async (quoteId) => {
      if (authtoken !== null) {
        let payload = jwtDecode(authtoken);
        let dateNow = Math.floor(Date.now() / 1000);
        const usertype = USERTYPE.QUOTESPAGE.includes(quoteId.userType);
        if (payload.exp < dateNow && usertype === false) {
          dispatch(checkValidation());
        }
      }
    },
    [authtoken, dispatch],
  );

  const updateCustomerFeedback = (data) => {
    dispatch(setCustomerFeedback(data));
  };

  const updateSublobDataState = (data) => {
    dispatch(setSublobDataState(data));
  };

  return {
    getQuote,
    quoteDetails,
    // fetchQuoteServiceDetails,
    getQuoteData,
    authtoken,
    autoPolicyDetails,
    updateCustomerFeedback,
    customerFeedback,
    paymentOptionsCheckState,
    additionalOptionsCheckState,
    otherCoveragesCheckState,
    paymentModeButtonStatus,
    seePaymentOptionButtonStatus,
    updateSublobDataState,
  };
};
